import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Product, ProductEnum } from '@uc/shared/data-models';
import {
	FeaturedPostgraduate,
	FeaturedUndergraduate,
	SourceTrackingTypes,
} from '@uc/web/shared/data-models';
import {
	BookEventBtnComponent,
	PrimaryBlueBtnComponent,
	ProspectusBtnComponent,
	RequestBtnComponent,
	VisitWebsiteBtnComponent,
	WriteReviewBtnComponent,
} from '@web/shared/ui';

@Component({
	selector: 'uc-cta-non-clearing',
	templateUrl: './cta-non-clearing.component.html',
	imports: [
		VisitWebsiteBtnComponent,
		RequestBtnComponent,
		BookEventBtnComponent,
		ProspectusBtnComponent,
		WriteReviewBtnComponent,
		PrimaryBlueBtnComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaNonClearingComponent {
	uniName = input.required<string>();
	sourceType = input.required<SourceTrackingTypes>();
	uniId = input.required<number>();
	externalUrl = input.required<string>();
	externalProspectusUrl = input.required<string>();
	isFeatured = input.required<FeaturedUndergraduate | FeaturedPostgraduate>();
	uniSlug = input.required<string>();
	externalEventsUrl = input.required<string>();

	isFeaturedPostgraduate = input<FeaturedPostgraduate>(false);
	isFeaturedUndergraduate = input<FeaturedUndergraduate>(false);
	product = input<Product | null>(null);
	componentName = input('Profile Header');
	privacyPolicyUrl = input('');
	courseName = input('');
	ugSearchOrderPosition = input<number | null>(null);

	universitiesLink = computed(
		() => `/universities/${this.product() ?? 'undergraduate'}`,
	);

	readonly productEnum = ProductEnum;
}
